/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Label_LegsInputs */

const en_us2_plan_label_legs = /** @type {(inputs: Plan_Label_LegsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legs`)
};

const pt_br2_plan_label_legs = /** @type {(inputs: Plan_Label_LegsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pernas`)
};

const es_419_plan_label_legs = /** @type {(inputs: Plan_Label_LegsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piernas`)
};

const pt_pt2_plan_label_legs = /** @type {(inputs: Plan_Label_LegsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pernas`)
};

const fr_fr2_plan_label_legs = /** @type {(inputs: Plan_Label_LegsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jambes`)
};

const de_de2_plan_label_legs = /** @type {(inputs: Plan_Label_LegsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beine`)
};

const it_it2_plan_label_legs = /** @type {(inputs: Plan_Label_LegsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gambe`)
};

/**
* | output |
* | --- |
* | "Legs" |
*
* @param {Plan_Label_LegsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_label_legs = /** @type {((inputs?: Plan_Label_LegsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Label_LegsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_label_legs(inputs)
	if (locale === "es-419") return es_419_plan_label_legs(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_label_legs(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_label_legs(inputs)
	if (locale === "de-DE") return de_de2_plan_label_legs(inputs)
	if (locale === "it-IT") return it_it2_plan_label_legs(inputs)
	return en_us2_plan_label_legs(inputs)
});
export { plan_label_legs as "plan.label_legs" }